// extracted by mini-css-extract-plugin
export default {"SUCCESS":"logs_SUCCESS__S4kWq","ERROR":"logs_ERROR__2wlqJ","INFO":"logs_INFO__dqzU9","WARNING":"logs_WARNING__KaaC8"};